var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
          fill: "#4868FD"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M16.2744 14.3542C18.8243 14.3542 20.8915 12.287 20.8915 9.73702C20.8915 7.18704 18.8243 5.11987 16.2744 5.11987C13.7244 5.11987 11.6572 7.18704 11.6572 9.73702C11.6572 12.287 13.7244 14.3542 16.2744 14.3542Z",
          fill: "#FFE252"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M26.6518 27.1544H5.66895V25.4629C5.66895 20.2972 9.82895 16.1372 14.9947 16.1372H17.3261C22.4918 16.1372 26.6518 20.2972 26.6518 25.4629V27.1544Z",
          fill: "#FFE252"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M22.1717 19.0628C22.2174 19.0171 22.2631 19.0171 22.2631 18.9714C22.5374 18.7885 23.086 18.2857 23.1317 18.1485C22.827 17.9107 22.3217 17.5535 21.9306 17.3446C21.3363 17.8932 21.166 17.92 20.7545 18.3771C20.6174 18.56 20.3888 18.56 20.0231 18.8342C19.9317 18.88 19.8403 18.9714 19.7031 19.0171C19.7945 18.9257 19.4745 19.0628 19.6117 18.9714C19.0631 19.3371 19.246 19.2457 18.6517 19.4742C17.5088 19.3828 18.286 19.84 16.8688 19.7028C16.9145 19.7028 16.9145 19.7028 16.9603 19.7028C16.6403 19.7028 15.726 19.84 16.5488 19.7942C15.9545 19.9771 15.1317 19.7485 16.366 19.7485C16.2288 19.7028 15.9088 19.7942 16.046 19.7028C15.9088 19.7942 14.8574 19.6571 15.2688 19.6114C15.0403 19.6114 14.8117 19.52 14.5831 19.4742C15.0403 19.5657 14.6745 19.5657 14.8574 19.6114C14.2631 19.5657 14.5374 19.4285 13.8974 19.2914C14.7203 19.5657 12.3431 18.88 12.846 18.9257C12.0231 18.5142 12.0688 18.56 11.7488 18.24C11.6574 18.1942 11.2003 17.92 11.4288 18.0114C11.2917 17.9657 11.0174 17.7371 11.4288 17.92C11.2917 17.8285 10.678 17.3411 10.6106 17.2183C10.6106 17.2183 10.1074 17.466 9.92526 17.5892C9.74311 17.7125 9.2793 18.082 9.2793 18.082C9.46215 18.4935 10.606 19.1542 10.1945 19.1085C10.4231 19.1085 11.2917 19.5657 10.6517 19.4742C10.7431 19.52 10.8345 19.6114 11.0174 19.7485C10.8803 19.4285 11.2003 19.7942 11.3831 19.9771C11.246 19.84 11.7945 19.9314 11.4745 20.0228C11.6117 20.0685 11.7488 20.1142 11.886 20.1142C11.7945 20.0685 11.8403 20.2057 11.886 20.2514C11.8403 20.2057 12.206 20.3885 12.2974 20.4342L12.1603 20.3428C12.9374 20.6171 13.0745 20.6628 13.9431 20.8457C13.0288 20.8457 13.6231 20.9828 13.3945 20.9828C14.2631 21.12 15.4517 21.2571 16.5031 21.2571C17.1431 21.2114 18.1031 20.8914 18.6974 20.9371C18.7431 20.8914 18.7888 20.8914 18.926 20.8457C18.8803 20.7542 21.3945 19.9771 22.1717 19.0628Z",
          fill: "#02016F"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }